import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './TransportAccessibility.css';
import { RateCard } from '../RateCard';
import { RateIndicator } from '../RateIndicator';
import { RateMark } from '../RateMark';

export interface ITransportTerm {
  rateLabel?: string;
  rateIndex: number;
  rateText: string;
  title: string;
}

export interface ITransportAccessibilityProps {
  description: string;
  iconUrl: string;
  maxRate: string;
  rate: string;
  terms: ITransportTerm[];
  title: string;
}

export const TransportAccessibility: React.VFC<ITransportAccessibilityProps> = ({
  description,
  iconUrl,
  rate,
  maxRate,
  terms,
  title,
}) => {
  return (
    <RateCard
      title={title}
      description={description}
      rateMark={<RateMark iconUrl={iconUrl} rate={rate} maxRate={maxRate} />}
      dataTestId="TransportAccessibility"
    >
      <div className={styles['terms']} data-testid="TransportAccessibilityTerms">
        {terms.map((term, idx) => (
          <React.Fragment key={idx}>
            <div className={styles['label']}>
              <UIText2>{term.title}</UIText2>
            </div>
            <div className={styles['indicator']}>
              <RateIndicator rate={term.rateIndex} ariaLabel={term.rateLabel} />
            </div>
            <div className={styles['rate']}>
              <UIText2>{term.rateText}</UIText2>
            </div>
          </React.Fragment>
        ))}
      </div>
    </RateCard>
  );
};
